import PropTypes from 'prop-types';
import { useRef, useCallback, useEffect } from 'react';
import IframeResizer from 'iframe-resizer-react';
import apiRequest from 'js/common/api_request';
import DOMPurify from 'dompurify';

const AiIframe = ({ url }) => {
  const iframeResizerRef = useRef(null);

  const handleAddGeneratedContentToCollection = useCallback(async (message) => {
    let status = "failed";
    try {
      const body = message.body || {};
      if (body.title && body.htmlContent) {
        const data = {
          page_resource: {
            title: body.title,
            body: DOMPurify.sanitize(body.htmlContent)
          }
        };
        const response = await createPageResource(data);
        if (response?.id) {
          const builderResponse = await addToBuilder(response.id);
          if (builderResponse) status = "completed";
        }
      }
    } catch (error) {
      console.error('Error adding content to collection:', error);
    }

    iframeResizerRef.current?.sendMessage({
      key: "addGeneratedContentToCollectionResult",
      body: { status },
    });
  }, []);

  const handleSignIn = useCallback((message) => {
    if (message.body?.returnUrl) {
      document.cookie = `ai_iframe_url=${encodeURIComponent(message.body.returnUrl)}; path=/; max-age=600; Secure; SameSite=Strict`;
      const currentUri = window.location.pathname + window.location.search;
      document.cookie = `return_to_ai_tab_path=${encodeURIComponent(currentUri)}; path=/; max-age=600; Secure; SameSite=Strict`;
      window.location.href = '/subscription/new';
    }
  }, []);

  const messageHandler = useCallback(async ({ message }) => {
    switch (message?.key) {
      case "addGeneratedContentToCollection":
        await handleAddGeneratedContentToCollection(message);
        break;
      case "signIn":
        handleSignIn(message);
        break;
    }
  }, [handleAddGeneratedContentToCollection, handleSignIn]);

  useEffect(() => {
    const navigateToTool = (event) => {
      const tool = event.detail.tool;
      iframeResizerRef.current?.sendMessage({
        key: "navigateToTool",
        body: { tool: tool }
      });
    };
    window.addEventListener("aiIframe:navigateToTool", navigateToTool);
    return () => window.removeEventListener("aiIframe:navigateToTool", navigateToTool);
  }, []);

  return (
    <IframeResizer
      forwardRef={iframeResizerRef}
      src={url}
      onMessage={messageHandler}
      style={{ width: '1px', minWidth: '100%', minHeight: 'calc(85vh - 3.5rem)' }}
      allow="clipboard-write"
    />
  );
};

AiIframe.propTypes = {
  url: PropTypes.string,
};

export default AiIframe;

const addToBuilder = async (resourceId) => {
  return document.dispatchEvent(
    new CustomEvent('search-card-add', {
      detail: {
        collectionItemType: "CollectionItemPageResource",
        id: resourceId,
        classType: "PageResource",
        searchCardAdd: true
      }
    })
  );
};

const createPageResource = async (data) => {
  const { data: [_message, item] } = await apiRequest.post(`${LP.config.page_resources_path}.json`, data);
  return item;
};
